import { jsx } from 'react/jsx-runtime';
import { useState, useCallback } from 'react';
import cns from '../../node_modules/classnames/index.js';
import Checkbox from '../Checkbox/Checkbox.js';
import { localStorage } from '../../utils/storage.js';

const MESSAGE_READ = 'messageRead';
function isDontShowAgainOptionSelected(id) {
    return id ? localStorage(id).load() === MESSAGE_READ : false;
}
function clearMessageStatus(id) {
    return id && localStorage(id).clear();
}
/**
Il componente gestisce una checkbox che mostra il messaggio di 'Non visualizzare più'
e memorizza lo stato sul localStorage.

Per sapere se il messaggio è stato letto, si può usare `DontShowAgain.isDontShowAgainOptionSelected`.
*/
function DontShowAgain({ message = 'Non visualizzare più', className = undefined, id }) {
    const [checked, setChecked] = useState(isDontShowAgainOptionSelected(id));
    const handleClick = useCallback(() => {
        const store = localStorage(id);
        const currentValue = store.load();
        const newValue = currentValue === MESSAGE_READ ? undefined : MESSAGE_READ;
        store.save(newValue);
        setChecked(newValue === MESSAGE_READ);
    }, [id]);
    return (jsx("div", { className: cns('dontshowagain', className), children: jsx(Checkbox, { checked: checked, label: message, onClick: handleClick }) }));
}
DontShowAgain.isDontShowAgainOptionSelected = isDontShowAgainOptionSelected;
DontShowAgain.clearMessageStatus = clearMessageStatus;

export { DontShowAgain as default };
